import { sendForm } from "./api";
import { PhoneInput } from "./PhoneInput";


interface SubmitParams {
  name: string
  phonenumber: string
  message: string
  form: string
  car: string
  storage: string
}

export function RegForm(storage: string, container:any, onSubmit?: any) {
  let error = '';
  let message = '';
  let isLoading = false;

  

  const form = document.createElement('form') as HTMLFormElement & {
    name: { value: string };
    phonenumber: { value: string };
    message: { value: string };
    car: { value: string };
    form: { value: string };
  }

  const formError = document.createElement('div')
  formError.classList.add('alert')





  form.addEventListener('submit', (event) => {
    event.preventDefault();
    if(isLoading) return;
    if(!form.form) return;

    isLoading = true;


    sendForm<SubmitParams>({
      name: form.name.value,
      phonenumber: form.phonenumber.value,
      form: form.form.value,
      message: form.message?.value,
      car: form.car.value,
      storage
    }).then((res)=>{
      // onSubmit()
      error = ''
      formError.innerText = error

      if('success' in res) {
        message = res.result.message
        form.innerHTML = message
      }

    })
    .catch((errorRes)=>{
      error = errorRes?.message
      formError.innerText = error
      form.appendChild(formError)
    })
    .finally(()=>{
      isLoading = false;
    })
  })




  form.innerHTML = `<input type="hidden" name="form" value="regFormModal"/>
    <div class="form-control-wrapper">
      <svg class="form-control-icon" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M20.142 18.0468C18.9638 15.9789 17.124 14.3676 14.9188 13.4723C16.0154 12.6498 16.8254 11.5032 17.2342 10.1947C17.6429 8.88628 17.6296 7.4824 17.1961 6.18195C16.7626 4.8815 15.9309 3.75041 14.8189 2.94889C13.7069 2.14737 12.3708 1.71606 11 1.71606C9.62921 1.71606 8.29317 2.14737 7.18112 2.94889C6.06907 3.75041 5.2374 4.8815 4.80392 6.18195C4.37044 7.4824 4.35711 8.88628 4.76584 10.1947C5.17457 11.5032 5.98462 12.6498 7.08126 13.4723C4.87603 14.3676 3.03622 15.9789 1.85798 18.0468C1.78497 18.1642 1.73631 18.295 1.71489 18.4316C1.69347 18.5682 1.69973 18.7077 1.7333 18.8418C1.76687 18.9759 1.82705 19.1019 1.91028 19.2123C1.99352 19.3226 2.09809 19.4152 2.21779 19.4843C2.33749 19.5535 2.46988 19.5979 2.60708 19.6148C2.74427 19.6318 2.88348 19.621 3.01643 19.5831C3.14938 19.5452 3.27334 19.481 3.38097 19.3942C3.48859 19.3074 3.57766 19.1999 3.6429 19.078C5.20009 16.3865 7.95009 14.7811 11 14.7811C14.0499 14.7811 16.7999 16.3873 18.3571 19.078C18.4985 19.3053 18.7227 19.4688 18.9824 19.5338C19.2421 19.5988 19.5169 19.5603 19.7487 19.4263C19.9805 19.2924 20.1512 19.0736 20.2246 18.8161C20.298 18.5587 20.2684 18.2828 20.142 18.0468ZM6.53126 8.24989C6.53126 7.36606 6.79334 6.50207 7.28438 5.76719C7.77541 5.03231 8.47333 4.45954 9.28989 4.12131C10.1064 3.78308 11.005 3.69458 11.8718 3.86701C12.7387 4.03944 13.5349 4.46504 14.1599 5.09001C14.7849 5.71497 15.2105 6.51123 15.3829 7.37808C15.5553 8.24494 15.4668 9.14345 15.1286 9.96001C14.7904 10.7766 14.2176 11.4745 13.4827 11.9655C12.7478 12.4566 11.8838 12.7186 11 12.7186C9.81524 12.7173 8.67939 12.246 7.84163 11.4083C7.00387 10.5705 6.53262 9.43466 6.53126 8.24989Z"
          fill="#0066FF" />
      </svg>
      <input type="text" name="name" class="form-control modal-form-control" required="" placeholder="Введите имя">
    </div>
    <div class="form-control-wrapper">
      <svg class="form-control-icon" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M6.06833 9.89083C7.38833 12.485 9.515 14.6117 12.1092 15.9317L14.1258 13.915C14.3825 13.6583 14.74 13.585 15.0608 13.6858C16.0875 14.025 17.1875 14.2083 18.3333 14.2083C18.5764 14.2083 18.8096 14.3049 18.9815 14.4768C19.1534 14.6487 19.25 14.8819 19.25 15.125V18.3333C19.25 18.5764 19.1534 18.8096 18.9815 18.9815C18.8096 19.1534 18.5764 19.25 18.3333 19.25C14.2004 19.25 10.2367 17.6082 7.31425 14.6857C4.39181 11.7633 2.75 7.79962 2.75 3.66667C2.75 3.42355 2.84658 3.19039 3.01849 3.01849C3.19039 2.84658 3.42355 2.75 3.66667 2.75H6.875C7.11812 2.75 7.35127 2.84658 7.52318 3.01849C7.69509 3.19039 7.79167 3.42355 7.79167 3.66667C7.79167 4.8125 7.975 5.9125 8.31417 6.93917C8.415 7.26 8.34167 7.6175 8.085 7.87417L6.06833 9.89083Z"
          fill="#0066FF" />
      </svg>
      <input data-telinput="tel" type="tel" name="phonenumber" class="form-control modal-form-control" required="" placeholder="Введите номер телефона">
    </div>
    <div class="form-control-wrapper">
      <svg class="form-control-icon" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M20.142 18.0468C18.9638 15.9789 17.124 14.3676 14.9188 13.4723C16.0154 12.6498 16.8254 11.5032 17.2342 10.1947C17.6429 8.88628 17.6296 7.4824 17.1961 6.18195C16.7626 4.8815 15.9309 3.75041 14.8189 2.94889C13.7069 2.14737 12.3708 1.71606 11 1.71606C9.62921 1.71606 8.29317 2.14737 7.18112 2.94889C6.06907 3.75041 5.2374 4.8815 4.80392 6.18195C4.37044 7.4824 4.35711 8.88628 4.76584 10.1947C5.17457 11.5032 5.98462 12.6498 7.08126 13.4723C4.87603 14.3676 3.03622 15.9789 1.85798 18.0468C1.78497 18.1642 1.73631 18.295 1.71489 18.4316C1.69347 18.5682 1.69973 18.7077 1.7333 18.8418C1.76687 18.9759 1.82705 19.1019 1.91028 19.2123C1.99352 19.3226 2.09809 19.4152 2.21779 19.4843C2.33749 19.5535 2.46988 19.5979 2.60708 19.6148C2.74427 19.6318 2.88348 19.621 3.01643 19.5831C3.14938 19.5452 3.27334 19.481 3.38097 19.3942C3.48859 19.3074 3.57766 19.1999 3.6429 19.078C5.20009 16.3865 7.95009 14.7811 11 14.7811C14.0499 14.7811 16.7999 16.3873 18.3571 19.078C18.4985 19.3053 18.7227 19.4688 18.9824 19.5338C19.2421 19.5988 19.5169 19.5603 19.7487 19.4263C19.9805 19.2924 20.1512 19.0736 20.2246 18.8161C20.298 18.5587 20.2684 18.2828 20.142 18.0468ZM6.53126 8.24989C6.53126 7.36606 6.79334 6.50207 7.28438 5.76719C7.77541 5.03231 8.47333 4.45954 9.28989 4.12131C10.1064 3.78308 11.005 3.69458 11.8718 3.86701C12.7387 4.03944 13.5349 4.46504 14.1599 5.09001C14.7849 5.71497 15.2105 6.51123 15.3829 7.37808C15.5553 8.24494 15.4668 9.14345 15.1286 9.96001C14.7904 10.7766 14.2176 11.4745 13.4827 11.9655C12.7478 12.4566 11.8838 12.7186 11 12.7186C9.81524 12.7173 8.67939 12.246 7.84163 11.4083C7.00387 10.5705 6.53262 9.43466 6.53126 8.24989Z"
          fill="#0066FF" />
      </svg>
      <input type="text" name="car" class="form-control modal-form-control" placeholder="Марка и номер автомобиля">
    </div>
    <div class="form-control-wrapper">
      <svg class="form-control-icon" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M2.97917 20.1667C2.97917 19.9844 3.0516 19.8095 3.18054 19.6806C3.30947 19.5517 3.48434 19.4792 3.66667 19.4792H18.3333C18.5157 19.4792 18.6905 19.5517 18.8195 19.6806C18.9484 19.8095 19.0208 19.9844 19.0208 20.1667C19.0208 20.3491 18.9484 20.524 18.8195 20.6529C18.6905 20.7818 18.5157 20.8542 18.3333 20.8542H3.66667C3.48434 20.8542 3.30947 20.7818 3.18054 20.6529C3.0516 20.524 2.97917 20.3491 2.97917 20.1667Z"
          fill="#0066FF" />
        <path
          d="M10.56 13.6848L15.9839 8.26089C15.071 7.88065 14.2421 7.32398 13.5447 6.62281C12.8431 5.92522 12.2861 5.09597 11.9057 4.18264L6.48083 9.60656C6.05733 10.0301 5.84558 10.2409 5.66408 10.4746C5.44908 10.7497 5.26495 11.0476 5.115 11.3629C4.98758 11.6296 4.89317 11.9138 4.70342 12.4812L3.70608 15.476C3.66032 15.613 3.65363 15.76 3.68677 15.9006C3.71991 16.0412 3.79157 16.1698 3.89371 16.2719C3.99585 16.3741 4.12443 16.4457 4.26502 16.4789C4.40561 16.512 4.55266 16.5053 4.68967 16.4596L7.6835 15.4622C8.25183 15.2725 8.536 15.1781 8.80275 15.0497C9.11931 14.8994 9.41539 14.7167 9.691 14.5016C9.92475 14.3191 10.1356 14.1074 10.5591 13.6848M17.4891 6.75573C17.7569 6.48788 17.9693 6.16992 18.1142 5.81999C18.2591 5.47006 18.3336 5.09502 18.3336 4.71628C18.3335 4.33753 18.2589 3.96251 18.1139 3.61261C17.9689 3.26272 17.7565 2.9448 17.4886 2.67702C17.2208 2.40924 16.9028 2.19683 16.5529 2.05193C16.203 1.90703 15.8279 1.83248 15.4492 1.83252C15.0704 1.83256 14.6954 1.9072 14.3455 2.05218C13.9956 2.19716 13.6777 2.40963 13.4099 2.67748L12.7591 3.32831L12.7875 3.41081C13.0258 4.09739 13.4759 4.99848 14.322 5.84456C15.0277 6.55444 15.8898 7.08936 16.8392 7.40656L17.4891 6.75573Z"
          fill="#0066FF" />
      </svg>
      <textarea name="message" class="form-control modal-form-control" placeholder="Задайте свой вопрос"></textarea>
    </div>
    <div class="mb24">
      <label class="aic fz18 g10"><input type="checkbox" class="form-checkbox" required="">Принимаю условия пользования</label>
    </div>
    <button class="btn btn-large w-full" type="submit">Записаться</button>`

  container.appendChild(form)
  const t = form.querySelector('[data-telinput]')
  t && PhoneInput(t)
  


}